"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnchorAllowedChild = exports.isBlockElement = exports.isInlineElement = exports.checkIfIsItAString = void 0;
var BLOCK_ELEMENTS = [
    'address',
    'article',
    'aside',
    'blockquote',
    'canvas',
    'dd',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hr',
    'li',
    'main',
    'nav',
    'noscript',
    'ol',
    'p',
    'pre',
    'section',
    'table',
    'tfoot',
    'ul',
    'video',
];
var INLINE_ELEMENTS = [
    'a',
    'abbr',
    'acronym',
    'b',
    'bdo',
    'big',
    'br',
    'button',
    'cite',
    'code',
    'dfn',
    'em',
    'i',
    'img',
    'input',
    'kbd',
    'label',
    'map',
    'object',
    'output',
    'q',
    'samp',
    'script',
    'select',
    'small',
    'span',
    'strong',
    'sub',
    'sup',
    'textarea',
    'time',
    'tt',
    'var',
];
var ANCHOR_ALLOWED_CHILDREN = [
    'Abierto',
    'Ahorro',
    'AhorroMovil',
    'Ajustes',
    'Alerta',
    'AMC',
    'AnadirMas',
    'Apagar',
    'ArrowLeftRight',
    'AtClientes',
    'Aura',
    'Auriculares',
    'Ayuda',
    'AyudaPregunta',
    'BBDD',
    'Blog',
    'Bombilla',
    'Buscar',
    'Calendario',
    'CalidadDeServicio',
    'CallCenter',
    'CalleTrece',
    'Campana',
    'CanalCero',
    'CasaSegura',
    'Cerrar',
    'Chat',
    'Cheuron',
    'CircleCheuron',
    'Cine',
    'CineIcon',
    'CineN',
    'CineRock',
    'ClaveWifi',
    'Clic',
    'Cloud',
    'Comedia',
    'ComedyCentral',
    'Compartir',
    'Comprar',
    'ComprarDatos',
    'CompraSegura',
    'ComprarPlanes',
    'ConfianzaOnline',
    'Configuracion',
    'ConfiguracionCorreo',
    'ConfiguracionRouter',
    'ConfigurarMovil',
    'ConsultaCanjes',
    'ConsultaDocumento',
    'Consumo',
    'CorazonSalud',
    'Dark',
    'Datos',
    'Deporte',
    'Deporte1',
    'Deporte2',
    'DeporteIcon',
    'Descargar',
    'DescargarApp',
    'Desco',
    'DescoMando',
    'DetalleLlamadas',
    'Dialogando',
    'Dinero',
    'Directorio',
    'Disney',
    'Documento',
    'Ecologico',
    'Envio',
    'Error',
    'Estrenos',
    'Euro',
    'EuroCirculo',
    'Eurosport',
    'Facebook',
    'Factura',
    'Favorito',
    'Fibra',
    'Fijo',
    'FijoInternet',
    'Filtro',
    'Formula1',
    'Foro',
    'Fox',
    'FoxLife',
    'FundacionTelefonica',
    'Fusion',
    'Futbol',
    'FutbolIcon',
    'Grabar',
    'Global',
    'Golf',
    'Hgu',
    'Home',
    'HomeDoor',
    'Hollywood',
    'Informacion',
    'Instagram',
    'Internet',
    'InternetMovil',
    'Juego',
    'Lanzamiento',
    'LaLiga',
    'LigaCampeones',
    'LineaAdicional',
    'Linkedin',
    'LlamadaEntrante',
    'LlamadaEspera',
    'LlamadaSaliente',
    'Mas80',
    'MeGusta',
    'MensDictados',
    'MisPedidos',
    'Motor',
    'MotorIcon',
    'Movil',
    'Movistar',
    'MovistarCar',
    'MovistarCircular',
    'MovistarLikes',
    'MovistarPlus',
    'MpaUp',
    'Multicontenido',
    'Multipantalla',
    'NoVer',
    'Noticias',
    'Nube',
    'Nubico',
    'Oferta',
    'OfertasExclusivas',
    'Ok',
    'Ont',
    'Opciones',
    'PagarFacturas',
    'PagoOnline',
    'Partidazo',
    'Perfil',
    'Play',
    'Portatil',
    'PriorityUser',
    'Producto',
    'Qustodio',
    'RealMadrid',
    'RechazoLlamada',
    'Reloj',
    'Router',
    'Seguridad',
    'SeguridadAbierta',
    'SeguroMovil',
    'Series',
    'SeriesExtras',
    'SeriesIcon',
    'SeriesMania',
    'ServicioTecnicoMovil',
    'Sim',
    'SinConexion',
    'Sms',
    'SoporteTecnico',
    'Star',
    'SundanceTv',
    'SYFY',
    'TarjetaCredito',
    'TaquillaUp',
    'TCM',
    'Telefonica',
    'TelefonicaFanshop',
    'Tiendas',
    'Tokens',
    'Tuenti',
    'Tv',
    'Twitter',
    'Ubicacion',
    'UHD',
    'Usuario',
    'U7D',
    'Vamos',
    'Ver',
    'Video',
    'ViolenciaDeGenero',
    'WhatsappBlue',
    'WhatsappGreen',
    'Xtra',
    'Youtube',
    'b',
    'i',
    'span',
    'strong',
    'sub',
    'sup',
    'svg',
    'SvgIcon',
    'SvgIconLoader',
    'SvgIconLabel',
    'TextInfo',
    'Notification',
    'button',
];
var checkIfIsItAString = function (input) {
    var inputRes = '';
    if (input && typeof input === 'string') {
        inputRes = input;
    }
    return inputRes;
};
exports.checkIfIsItAString = checkIfIsItAString;
var isInlineElement = function (tagType) {
    var myTagType = (0, exports.checkIfIsItAString)(tagType);
    var tagType2Cmp = myTagType.toLowerCase();
    var founded = INLINE_ELEMENTS.find(function (element) {
        var element2Cmp = element.toLowerCase();
        return element2Cmp === tagType2Cmp;
    });
    return (!!founded);
};
exports.isInlineElement = isInlineElement;
var isBlockElement = function (tagType) {
    var myTagType = (0, exports.checkIfIsItAString)(tagType);
    var tagType2Cmp = myTagType.toLowerCase();
    var founded = BLOCK_ELEMENTS.find(function (element) {
        var element2Cmp = element.toLowerCase();
        return element2Cmp === tagType2Cmp;
    });
    return (!!founded);
};
exports.isBlockElement = isBlockElement;
var isAnchorAllowedChild = function (tagType) {
    var myTagType = (0, exports.checkIfIsItAString)(tagType);
    var tagType2Cmp = myTagType.toLowerCase();
    var founded = ANCHOR_ALLOWED_CHILDREN.find(function (element) {
        var element2Cmp = element.toLowerCase();
        return element2Cmp === tagType2Cmp;
    });
    return (!!founded);
};
exports.isAnchorAllowedChild = isAnchorAllowedChild;
//# sourceMappingURL=index.js.map